export const ADD_TO_ANY_SHARE_SCRIPT_STATIC_URL = "https://static.addtoany.com/menu/page.js";